import { clearDisable } from '../plugins/clickThrottling';

export const SHOW_DIALOG = 'showDialog';
export const SHOW_TIPS_MSG = 'showTIpsMessage';
export const BINDING_DIALOG = 'bindingDialog';
export const DE_BIND_DIALOG = 'debindDialog';
export const SWICH_ACCOUNT_DIALOG = 'switchAccountDialog';
export const SWICH_TIPS_DIALOG = 'switchAccountTipsDialog';
export const HIDE_DIALOG = 'hideDialog';
export const SHOW_TOST = true;
export const HIDE_TOST = false;
export const TOST = '';
export default {
  state: {
    showTost: false,
    textLeft: false, // 文字左对齐
    preWrap: false, // 文字支持换行
    isScroll: false, // 是否出现滚动条
    tipContent: '',
    tostContent: '',
    showDialog: false,
    showingDialogType: '',
    BINDING_DIALOG,
    SHOW_TIPS_MSG,
    DE_BIND_DIALOG,
    SWICH_ACCOUNT_DIALOG,
    SWICH_TIPS_DIALOG,
    tipsConfirmCallbackType: '',
    tipsCancelCallback: '',
    tipsCloseCallBack: '',
    tostShowStatus: false
  },
  mutations: {
    [SHOW_DIALOG](state, TYPE) {
      state.showDialog = true;
      state.showingDialogType = TYPE;
    },
    [SHOW_TIPS_MSG](
      state,
      {
        message,
        tipsConfirmCallback,
        tipsCancelCallback,
        tipsCloseCallBack,
        textLeft,
        preWrap,
        isScroll
      }
    ) {
      state.tipContent = message;
      state.tipsConfirmCallbackType = tipsConfirmCallback || '';
      state.tipsCancelCallback = tipsCancelCallback || '';
      state.tipsCloseCallBack = tipsCloseCallBack || '';
      state.textLeft = textLeft;
      state.preWrap = preWrap;
      state.isScroll = isScroll;
      clearDisable();
    },
    [HIDE_DIALOG](state) {
      state.showDialog = false;
      state.showingDialogType = '';
    },
    [TOST](state, { message, showStatus }) {
      state.tostContent = message;
      state.tostShowStatus = showStatus;
    }
  },
  actions: {
    [SHOW_TIPS_MSG]({ commit, dispatch }, options) {
      dispatch(SHOW_DIALOG, SWICH_TIPS_DIALOG);
      commit(SHOW_TIPS_MSG, options);
    },
    [SHOW_DIALOG]({ commit }, TYPE) {
      commit(SHOW_DIALOG, TYPE);
    },
    [HIDE_DIALOG]({ commit }) {
      commit(HIDE_DIALOG);
    },
    [TOST]({ commit }, message) {
      commit(TOST, {
        message,
        showStatus: true
      });
      setTimeout(() => {
        commit(TOST, {
          message: '',
          showStatus: false
        });
      }, 1500);
    }
  }
};
